// extracted by mini-css-extract-plugin
export var grid = "sign-in-selector-module--grid--13d48";
export var gridWithRowGap = "sign-in-selector-module--grid--with-row-gap--14b28";
export var maxWidthContainer = "sign-in-selector-module--max-width-container--8bf16";
export var mt0 = "sign-in-selector-module--mt-0--102f4";
export var mt1 = "sign-in-selector-module--mt-1--66906";
export var mt2 = "sign-in-selector-module--mt-2--7e946";
export var mt3 = "sign-in-selector-module--mt-3--6c386";
export var mt4 = "sign-in-selector-module--mt-4--32efe";
export var mt5 = "sign-in-selector-module--mt-5--1ba8f";
export var mt6 = "sign-in-selector-module--mt-6--a476e";
export var removeVisuallyHidden = "sign-in-selector-module--remove-visually-hidden--333ae";
export var signInSelector__icon = "sign-in-selector-module--sign-in-selector__icon--fe432";
export var signInSelector__link = "sign-in-selector-module--sign-in-selector__link--7d63a";
export var signInSelector__linkButton = "sign-in-selector-module--sign-in-selector__link-button--e3594";
export var signInSelector__linkFocus = "sign-in-selector-module--sign-in-selector__link--focus--bc19f";
export var visuallyHidden = "sign-in-selector-module--visually-hidden--ef4ae";
export var widgetBase = "sign-in-selector-module--widget-base--2698f";